import { Component, OnInit, OnDestroy } from '@angular/core';
import { FacultyService} from '../../Services/faculty.service'
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-faculty',
  templateUrl: './faculty.component.html',
  styleUrls: ['./faculty.component.scss']
})
export class FacultyComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  constructor(private facultyService: FacultyService, private router: Router, public appComponent: AppComponent) { }
  Facultydata: any[];
  url: any;
  index: any = 0;
  isLoading: boolean = false;
  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    this.getFacultyDetails();
  }
  getFacultyDetails() {
    this.isLoading = true;
    this.subscription = this.facultyService.GetFaculty().subscribe(res => {
      this.isLoading = false;
      if (res != null) {
        this.Facultydata = res.Response.Data.FacultyList;
      }
    }, err => {
      console.log('err in faculty component', err);
      this.isLoading = false;
    });
  }
  onNavigate(type, data)
  {
    if (this.index > 0) {
      type = "Default";
    }
    if (data == null || data == '') {
      return;
    }
    if (type == "Detail") {
      setTimeout(() => {
        this.router.navigate(['/faculty-detail', data]);
      }, 5);
    }
    else if (type == "facebook") {
      this.index = this.index + 1;
      window.open(data);
    }
    else if (type == "instagram") {
      this.index = this.index + 1;
      window.open(data);
    }
    else if (type == "website") {
      this.index = this.index + 1;
      window.open(data);
    }
    else if (type == "Default") {
      this.index = 0;
    }
    else {
      console.log('err in faculty component - detail & social links');
    }
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
